export default "__VITE_ASSET__CJ5rC95F__"